import {Button, Flex, TreeNodeProps} from '@priority-software/priority-style-react';
import React, {FC} from 'react';
import {useEmailContext} from '../context';
import {texts} from '../texts';
import styles from './styles.module.scss';
import {TVoidFunction} from '../types';
import {createDataTestId} from '../../../utils/dataTestId';

interface IFooterEmailEditor {
    onClose: TVoidFunction;
    treeValues: TreeNodeProps;
}

export const FooterEmailEditor: FC<IFooterEmailEditor> = ({onClose, treeValues}) => {
    const {
        handlers: {onBack, saveEmailEditor, updateEmailHTML},
        states
    } = useEmailContext();

    const {isDirty} = states;

    const updateHTML = (
        cb: ({
            emailHtml,
            language,
            treeValues
        }: {
            emailHtml: string;
            language: string;
            treeValues: TreeNodeProps;
        }) => Promise<void>
    ): Promise<string | void> =>
        updateEmailHTML().then(({emailHtml, language}) => cb({emailHtml, language, treeValues}));

    return (
        <Flex
            {...createDataTestId(`email-footer-container`, true)}
            componentClasses={styles.gap}
            justifyContent="flex-end"
        >
            <Button
                {...createDataTestId(`email-footer-cancel-button`, true)}
                width="regularFixed"
                size="medium"
                skin="secondary"
                onClick={() => onBack(onClose)}
            >
                {texts.cancel}
            </Button>
            <Button
                {...createDataTestId(`email-footer-save-button`, true)}
                width="regularFixed"
                size="medium"
                skin="primary"
                disabled={!isDirty}
                onClick={async () => {
                    await updateHTML(({emailHtml, language}) =>
                        saveEmailEditor({htmlString: emailHtml, language, treeValues})
                    );
                    onClose();
                }}
            >
                {texts.save}
            </Button>
        </Flex>
    );
};
